import { render } from "./CommerceProductSearch.vue?vue&type=template&id=69a0628f&scoped=true"
import script from "./CommerceProductSearch.vue?vue&type=script&lang=js"
export * from "./CommerceProductSearch.vue?vue&type=script&lang=js"

import "./CommerceProductSearch.vue?vue&type=style&index=0&id=69a0628f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a0628f"]])

export default __exports__